import type React from 'react';

import type Cropper from 'cropperjs';

import { ImageCropper } from '../imageCropper';
import { ImageUploader } from '../imageUploader';
import type { RawMediaCropInput, UploaderMethodProps } from '../types';

type Props = {
	crop?: RawMediaCropInput | undefined;
	disabled?: boolean;
	image?: string | null;
	onImageChange: (image: string | undefined) => void;
	onImageCrop: (imageCrop: RawMediaCropInput | undefined) => void;
	onButtonClick?: () => void;
	onCancelClick?: () => void;
	uploader: UploaderMethodProps;
	buttonTheme?: 'gray';
	onInitialized?: (instance: Cropper) => void;
	buttonSize?: 'small';
};

export const ImageCropperUploader: React.FC<Props> = ({
	crop,
	disabled = false,
	image,
	onButtonClick,
	onImageCrop,
	onImageChange,
	onCancelClick,
	uploader,
	buttonTheme,
	onInitialized,
	buttonSize,
}) => {
	return (
		<>
			{image && (
				<ImageCropper
					crop={crop}
					disabled={disabled}
					image={image}
					onCancelClick={onCancelClick}
					onImageChange={onImageChange}
					onImageCrop={onImageCrop}
					uploader={uploader}
					onInitialized={onInitialized}
				/>
			)}
			{!image && (
				<ImageUploader
					disabled={disabled}
					onButtonClick={onButtonClick}
					uppy={uploader.uppy}
					buttonTheme={buttonTheme}
					buttonSize={buttonSize}
				/>
			)}
		</>
	);
};
